<template>
    <v-container class="categories">
        <v-row tag="ul" class="categorie-list">
            <li
                class="item"
                v-for="(item, index) in lv1_categories"
                :key="index"
                @click="on_chang_page_tags(item.driveId, item.fileId)"
            >
                <v-icon dense color=" darken-2">mdi-folder</v-icon>
                <span>{{ item.name }}</span>
            </li>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
    computed: {
        ...mapState("global", ["navInfos", "driveIdsID"])
    },
    data: () => {
        return {
            lv1_categories: []
        };
    },
    watch: {
        navInfos: function(newValue) {
            this.lv1_categories_data(newValue);
        },
        driveIdsID: function() {
            this.lv1_categories_data(this.navInfos);
        }
    },
    created() {
        this.lv1_categories_data(this.navInfos);
    },

    methods: {
        ...mapMutations("global", [
            "updateAllCardList",
            "updateAllCardListMeta",
            "updateDriveIdsID",
            "updateLv1_ID"
        ]),

        on_chang_page_tags(driveId, fileId) {
            this.updateAllCardList("");
            this.$router.push(`/${driveId}/${fileId}`);
            this.updateLv1_ID([fileId]);
        },

        lv1_categories_data(data) {
            data.map(k => {
                if (k.driveId == this.$route.params.categories) {
                    this.lv1_categories = k.lv1_categories;
                }
            });
        }
    }
};
</script>

<style lang="scss">
.container {
    padding: 44px 12px;
}
.categorie-list {
    justify-content: flex-start;
    flex-wrap: wrap;
    .item {
        width: calc((100% / 6) - 20px);
        padding: 13px 16px;
        border: 1px solid #dadce0;
        border-radius: 4px;
        margin: 10px;
        transition: 0.3s all;
        cursor: pointer;

        display: flex;
        color: $color-text;
        .v-icon {
            color: $color-icon;
            padding-right: 14px;
        }
        span {
            display: block;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &:hover {
            border-color: $color-main;
        }
    }

    @media (max-width: 1200px) {
        .item {
            width: calc((100% / 4) - 20px);
        }
    }
}
</style>
